import {
    all, select, takeLatest,
} from 'redux-saga/effects';

import Scopes from '../../constants/Scopes';
import { getScopeSelector } from '../../commons/reduxModules/Authentication';
import gtmInit from '../trackers/gtm';
import trustPilotInit from '../trackers/trustpilot';
import hotjarInit from '../trackers/hotjar';
import googleOptimizeInit from '../trackers/googleOptimize';

import {
    INIT_CMP_APP,
} from '../reduxModules/ConsentManagementPlatform';

export function* callAction() {
    const scope = yield select(getScopeSelector);
    if (scope !== Scopes.USER) return;
    yield all([
        gtmInit(),
        trustPilotInit(),
    ]);
    // Use hotjar only on professionnal pages of yurplan.com
    if (window.location.pathname.indexOf('/pro') === 0) {
        yield hotjarInit();
        yield googleOptimizeInit();
    }
}

export function* watch() {
    yield takeLatest(INIT_CMP_APP, callAction);
}
